import { render, staticRenderFns } from "./WorkspaceMemberSettings.vue?vue&type=template&id=efda710a"
import script from "./WorkspaceMemberSettings.vue?vue&type=script&lang=js"
export * from "./WorkspaceMemberSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports